// extracted by mini-css-extract-plugin
export default {"sendItem":"SendItem_sendItem__CwE5y","row":"SendItem_row__fRHPl","col":"SendItem_col__9pJX2","profilePic":"SendItem_profilePic__lnWrx"};